import { render, staticRenderFns } from "./departure-picker.vue?vue&type=template&id=1670bfef&scoped=true&"
import script from "./departure-picker.vue?vue&type=script&lang=js&"
export * from "./departure-picker.vue?vue&type=script&lang=js&"
import style0 from "./departure-picker.vue?vue&type=style&index=0&id=1670bfef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670bfef",
  null
  
)

export default component.exports